import { render, staticRenderFns } from "./ReporteControlVentasSR.vue?vue&type=template&id=0b0a1dbb"
import script from "./ReporteControlVentasSR.vue?vue&type=script&lang=js"
export * from "./ReporteControlVentasSR.vue?vue&type=script&lang=js"
import style0 from "./ReporteControlVentasSR.vue?vue&type=style&index=0&id=0b0a1dbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports